import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=f05a4410&scoped=true&lang=pug&"
import script from "./MenuItem.vue?vue&type=script&lang=ts&"
export * from "./MenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=f05a4410&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a4410",
  null
  
)

export default component.exports